import { CalculationStates, SystemConfigurations } from '@/interfaces'

export enum ProjectsPreviewType {
  GRID,
  TABLE,
  MAP
}

export interface ProjectFilterValues {
  selectedCalculationState?: CalculationStates
  selectedSystemConfiguration?: SystemConfigurations
  selectedCalculationStartDate?: Date
}
